"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultStorage = void 0;
class DefaultStorage {
    constructor() {
        this.store = typeof window !== 'undefined' ? window.localStorage : stubbedLocalStorage;
    }
    save(storeKey, data) {
        this.store.setItem(storeKey, JSON.stringify(data));
    }
    load(storeKey) {
        return new Promise((resolve) => {
            const item = this.store.getItem(storeKey);
            resolve(item ? JSON.parse(item) : undefined);
        });
    }
    remove(storeKey) {
        this.store.removeItem(storeKey);
    }
}
exports.DefaultStorage = DefaultStorage;
const stubbedLocalStorage = {
    getItem: () => null,
    setItem: () => undefined,
    removeItem: () => undefined,
    clear: () => undefined,
    key: () => null,
    length: 0
};
exports.default = DefaultStorage;
//# sourceMappingURL=DefaultStorage.js.map